/**
 * Client for `POST /api/builder/translations` (PT plan, phase 4).
 *
 * The builder proxies to the portal, which holds the tenant's model. Every
 * id comes back translated or the request fails: the editor never fills a
 * PT field with anything but a translation.
 */

import { api } from "@/lib/api";

export interface TranslationSource {
  en: string;
  es: string;
}

export interface TranslationResult {
  target: string;
  translations: Record<string, string>;
}

export const translationsApi = {
  translate: (target: "pt", texts: Record<string, TranslationSource>) =>
    api.post<TranslationResult>("/api/builder/translations", { target, texts }),
};
